import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadPaymentMethods, createPaymentConfiguration, updatePaymentConfiguration } from './actions';
import List from './List';
import authUtils from '../../auth/utils';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import PaymentSettingsDialog from './SettingsDialog';
import { withTranslation } from 'react-i18next';
import { paymentOwners } from './methods/common';
import { selector as paymentConfigurationFormSelector } from './SettingsForm';
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';

class Payments extends Component {

	constructor(props) {
		super(props);
		this.handleEnable = this.handleEnable.bind(this);
		this.handleDisable = this.handleDisable.bind(this);
		this.handleConfigure = this.handleConfigure.bind(this);
		this.handleSaveConfiguration = this.handleSaveConfiguration.bind(this);
		this.hideConfigurationDialog = this.hideConfigurationDialog.bind(this);
		this.state = {
			selectedPaymentMethodName: null,
			selectedPaymentMethodConfiguration: null,
			showConfigurationDialog: false,
		};
	}

	componentDidMount() {
		this.loadData(() => {
			// show dialog for method selected in query string
			if (this.props.selectedPaymentMethodName) {
				const paymentMethod = this.props.paymentMethods.find(x => x.name.toLowerCase() === this.props.selectedPaymentMethodName.toLowerCase())
				this.handleConfigure(paymentMethod);
			}
		});
	}

	loadData(onSuccess) {
		this.props.loadEntities(this.props.owner, onSuccess);
	}

	handleEnable(paymentMethod) {
		const values = paymentMethod.configuration;
		if (values) {
			const newValues = { paymentMethodId: paymentMethod.id, ...values, enabled: true };
			this.update(paymentMethod.configuration.id, newValues);
		} else {
			const initalValues = { ...this.props.owner, paymentMethodId: paymentMethod.id, enabled: true };
			this.create(initalValues);
		}
	}

	handleDisable(paymentMethod) {
		const values = { paymentMethodId: paymentMethod.id, ...paymentMethod.configuration, enabled: false };
		this.update(paymentMethod.configuration.id, values);
	}

	handleConfigure(paymentMethod) {
		this.setState({ selectedPaymentMethodName: paymentMethod.name }, () => {
			const values = paymentMethod.configuration;
			if (values) {
				this.showConfigurationDialog();
			} else {
				const initalValues = { ...this.props.owner, paymentMethodId: paymentMethod.id, enabled: false };
				this.create(initalValues);
			}
		});
	}

	showConfigurationDialog() {
		const { selectedPaymentMethodName } = this.state;
		if (selectedPaymentMethodName) {
			const paymentMethod = this.props.paymentMethods.find(x => x.name === selectedPaymentMethodName);
			if (paymentMethod) {
				let data = paymentMethod.configuration;
				//if (!data) {
				//	data = {
				//		...this.props.owner, paymentMethod: { id: paymentMethod.id }, configurationJson: JSON.stringify({ additionalFee: 0 })};
				//}
				this.setState({
					selectedPaymentMethodConfiguration: data,
					showConfigurationDialog: true
				});
			}
		}
	}

	hideConfigurationDialog() {
		this.setState({
			showConfigurationDialog: false,
			selectedPaymentMethodName: null,
			selectedPaymentMethodConfiguration: null
		});
	}

	handleSaveConfiguration(data, values) {
		const { enabled, hiddenForParents, enableOneOffPayments, enableRecurringPayments, ...configValues } = values;
		if (configValues && configValues.additionalFee === "") {
			configValues.additionalFee = 0;
		}
		const newValues = { ...data, paymentMethodId: data.paymentMethod.id, enabled, hiddenForParents, enableOneOffPayments, enableRecurringPayments, configurationJson: JSON.stringify(configValues) };
		if (data.id) {
			this.update(data.id, newValues);
		} else {
			this.create(newValues);
		}
	}

	update(id, values) {
		const onSuccessEvent = () => this.loadData(() => this.showConfigurationDialog());
		this.props.updatePaymentConfiguration(id, values, onSuccessEvent);
	}

	create(values) {
		const onSuccessEvent = () => this.loadData(() => this.showConfigurationDialog());
		this.props.createPaymentConfiguration(values, onSuccessEvent);
	}

	render() {
		const { hasPermission, paymentMethods, ...rest } = this.props;
		return (
			<div>
				{
					hasPermission &&
					<div>
						<CollapsablePanel icon={faCreditCard} title={this.props.panelTitle} collapsed={this.props.collapsed}>
							<List
								onEnable={this.handleEnable}
								onDisable={this.handleDisable}
								onConfigure={this.handleConfigure}
								data={paymentMethods}
								{...rest}
							/>
						</CollapsablePanel>
						<PaymentSettingsDialog
								show={this.state.showConfigurationDialog}
								method={this.state.selectedPaymentMethodName}
								data={this.state.selectedPaymentMethodConfiguration}
								onSaveConfiguration={this.handleSaveConfiguration}
								onConfigurationUpdated={() => this.loadData(() => this.showConfigurationDialog())}	// when config data is updated from another component (GoCardless OAuth)
								onCancel={this.hideConfigurationDialog}
								{...rest}
						/>
					</div>
				}
			</div>
		);
	}

}

const mapStateToProps = (state, ownProps) => {
	const {
		entities: { paymentMethodsByOwner },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	let { paymentOwnerId, paymentOwnerType } = ownProps;
	if (!paymentOwnerId && paymentOwnerType === paymentOwners.franchisor) {
		paymentOwnerId = franchisor.id;
	}
	const uniqueOwnerId = `${paymentOwnerType}-${paymentOwnerId}`;
	const paymentMethods = paymentMethodsByOwner[uniqueOwnerId];

	return {
		franchisor,
		owner: {
			paymentOwnerId,
			paymentOwnerType
		},
		paymentMethods: paymentMethods && Object.values(paymentMethods.data),
		hasPermission: authUtils.hasPermission(currentUser, 'PaymentConfiguration'),
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentConfiguration') ||
			(paymentOwnerType === paymentOwners.franchisor && authUtils.hasReadOnlyPermission(currentUser, 'FranchisorSettings')),
		paymentConfigurationFormValues: { enabled: paymentConfigurationFormSelector(state, 'enabled') }
	};
};

const mapDispatchToProps = {
	loadEntities: loadPaymentMethods,
	createPaymentConfiguration,
	updatePaymentConfiguration
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Payments));